import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-call-report',
  templateUrl: './call-report.component.html',
  styleUrls: ['./call-report.component.scss']
})
export class CallReportComponent {

  public company_uuid;
  public loading: boolean = false;
  public data:any = {}
  public lists:any = [];
  
  constructor(private http: HttpService, private cdr : ChangeDetectorRef, private router: Router, private activateRoute: ActivatedRoute) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });

    this.activateRoute.params.subscribe((v:any) => {
      if(!v.call_report_uuid || v.call_report_uuid == "new" || v.call_report_uuid == "") {
        this.data = {}
      } else {
        this.init(v.call_report_uuid);
      }
    })

    this.getList();
   }

  async getList() {
    this.lists = await this.http.post("/admin/call-report/get-list")
  }

  async init(call_report_uuid:string) {
    let y = await this.http.post("/admin/call-report/get", {uuid: call_report_uuid})
    this.data = y;
  }
  
  async submit() {

    if(!this.data.title || !this.data.descp) {
      alert("Title and description are required.")
      return;
    }

    this.loading = true;
    let rtn:any = await this.http.post("/admin/call-report/save", this.data)

    if(rtn.uuid) {
      this.router.navigate(['/lo', this.company_uuid, 'call-report', rtn.uuid])
      this.http.notify("Note Saved.")
    }

    await this.getList();
    this.loading = false;
  }

}
